// /src/renderer/shared/components/Table/TableRow.tsx
import React, { HTMLAttributes } from "react";
// import "./TableRow.scss";
import styles from  "./TableRow.module.scss";

export interface TableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  selected?: boolean;
  expandable?: boolean;
  children: React.ReactNode;
  className?: string;
}

function TableRow({
  selected = false,
  expandable = false,
  children,
  onClick,
  className = "",
  ...props
}: TableRowProps): React.JSX.Element {
  return (
    <tr
      className={`${styles.row} ${expandable ? styles.expandable : ""} ${selected ? styles.selected : ""} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </tr>
  );
}

export default TableRow;
